/* eslint-disable @typescript-eslint/camelcase */

import { BcsFlag } from "../unleash";

const BcsPermissionUrgentDelivery = {
  config_eligible_urgent_delivery: new BcsFlag.JSONFlag([
    "BKD",
    "PUP",
    "STI-SC",
    "STI",
    "INHUB",
    "OUTHUB",
    "BAGGING",
    "CARGO PLANE",
    "CARGO TRUCK",
    "CARGO TRAIN",
    "CARGO SHIP",
    "PICKUP TRUCK",
    "DROPOFF TRUCK",
    "TRANSIT",
    "STI-DEST",
    "STI-DEST-SC",
    "KONDISPATCH",
    "STLDISPATCH",
    "HND",
    "DEL",
    "STT REMOVE",
    "STT ADJUSTED",
    "HAL",
    "ODA",
    "OCC",
    "STO-SC",
    "INTHND",
    "INT-STI",
    "OCC-EXP",
    "OCC-IMP"
  ]),
  config_eligible_delivery_ulang: new BcsFlag.JSONFlag(["DEX", "HAL"]),
  config_eligible_rts: new BcsFlag.JSONFlag([
    "BKD",
    "PUP",
    "STI-SC",
    "STI",
    "INHUB",
    "OUTHUB",
    "BAGGING",
    "CARGO PLANE",
    "CARGO TRUCK",
    "CARGO TRAIN",
    "CARGO SHIP",
    "PICKUP TRUCK",
    "DROPOFF TRUCK",
    "TRANSIT",
    "STI-DEST",
    "STI-DEST-SC",
    "KONDISPATCH",
    "STLDISPATCH",
    "HND",
    "DEL",
    "DEX",
    "STT REMOVE",
    "SHORTLAND",
    "MIS-ROUTE",
    "STT ADJUSTED",
    "HAL",
    "ODA",
    "CI",
    "MISSING",
    "DAMAGE",
    "NOT RECEIVED",
    "OCC",
    "MISBOOKING",
    "STO-SC",
    "INTHND",
    "INT-STI",
    "OCC-EXP",
    "OCC-IMP",
    "REJECTED"
  ]),
  config_eligible_hal: new BcsFlag.JSONFlag([
    "BKD",
    "PUP",
    "STI-SC",
    "STI",
    "INHUB",
    "OUTHUB",
    "BAGGING",
    "CARGO PLANE",
    "CARGO TRUCK",
    "CARGO TRAIN",
    "CARGO SHIP",
    "PICKUP TRUCK",
    "DROPOFF TRUCK",
    "TRANSIT",
    "STI-DEST",
    "STI-DEST-SC",
    "KONDISPATCH",
    "STLDISPATCH",
    "HND",
    "DEL",
    "STT REMOVE",
    "STT ADJUSTED",
    "ODA",
    "OCC",
    "STO-SC",
    "INTHND",
    "INT-STI",
    "OCC-EXP",
    "OCC-IMP"
  ]),
  config_eligible_override: new BcsFlag.JSONFlag({
    "Kiriman Penting": ["Kiriman Penting", "RTS", "HAL"],
    "Delivery Ulang": ["Kiriman Penting", "Delivery Ulang", "RTS", "HAL"],
    "RTS": ["RTS"],
    "HAL": ["Delivery Ulang", "RTS", "HAL"]
  })
}

export const FlagsPermissionUrgentDelivery = {
  ...BcsPermissionUrgentDelivery
};

export function initFlagsPermissionUrgentDelivery() {
  // register flags with namespaces for better grouping
  BcsFlag.register("featureUrgentDelivery", FlagsPermissionUrgentDelivery);
}
